(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-announcement-bar]');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('[data-announcement-slide]'));
    if (slides.length === 0) return;

    const prev = root.querySelector('[data-announcement-prev]');
    const next = root.querySelector('[data-announcement-next]');
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    let timer = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
    };

    const stopAutoplay = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      const viewport = root.querySelector('[data-announcement-viewport]');
      if (!viewport || !viewport.hasAttribute('data-announcement-autoplay') || slides.length < 2) return;
      const seconds = Number(viewport.getAttribute('data-announcement-interval')) || 5;
      timer = window.setInterval(() => show(index + 1), Math.max(3, seconds) * 1000);
    };

    prev?.addEventListener('click', () => {
      stopAutoplay();
      show(index - 1);
    });

    next?.addEventListener('click', () => {
      stopAutoplay();
      show(index + 1);
    });

    root.addEventListener('focusin', stopAutoplay);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cart-qty-control]').forEach((control) => {
      const input = control.querySelector('[data-cart-qty-input]');
      const minusButton = control.querySelector('[data-cart-qty-change="-1"]');
      const plusButton = control.querySelector('[data-cart-qty-change="1"]');
      const buttons = control.querySelectorAll('[data-cart-qty-change]');
      if (!(input instanceof HTMLInputElement)) return;

      const syncState = () => {
        const min = Number(input.min || 0);
        const rawMax = input.max;
        const max = rawMax !== '' ? Number(rawMax) : null;
        const current = Number(input.value) || min;

        if (max !== null && Number.isFinite(max) && current > max) {
          input.value = String(max);
        }

        const effectiveCurrent = Number(input.value) || min;
        if (minusButton instanceof HTMLButtonElement) {
          minusButton.disabled = effectiveCurrent <= min;
        }
        if (plusButton instanceof HTMLButtonElement) {
          plusButton.disabled = max !== null && Number.isFinite(max) ? effectiveCurrent >= max : false;
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const delta = Number(button.getAttribute('data-cart-qty-change'));
          const min = Number(input.min || 0);
          const rawMax = input.max;
          const max = rawMax !== '' ? Number(rawMax) : null;
          const current = Number(input.value) || min;
          let next = Math.max(min, current + delta);
          if (max !== null && Number.isFinite(max)) {
            next = Math.min(max, next);
          }
          input.value = String(next);
          syncState();
        });
      });

      input.addEventListener('change', syncState);
      syncState();
    });

    document.querySelectorAll('[data-cart-qty-mobile-input]').forEach((mobileInput) => {
      if (!(mobileInput instanceof HTMLInputElement)) return;
      const sourceSelector = mobileInput.getAttribute('data-cart-qty-source');
      if (!sourceSelector) return;
      const sourceInput = document.querySelector(sourceSelector);
      if (!(sourceInput instanceof HTMLInputElement)) return;

      const syncToSource = () => {
        sourceInput.value = mobileInput.value;
      };

      mobileInput.addEventListener('input', syncToSource);
      mobileInput.addEventListener('change', syncToSource);
      syncToSource();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const filtersRoot = document.querySelector('.collection-filters');
    if (!filtersRoot) return;

    const form = filtersRoot.querySelector('form');
    const mobileMq = window.matchMedia('(max-width: 900px)');
    let userAdjustedFilters = false;

    const applyDefaultFilterAccordionState = () => {
      const isMobile = mobileMq.matches;
      if (userAdjustedFilters) return;

      filtersRoot.querySelectorAll('[data-collection-filter]').forEach((details) => {
        if (!(details instanceof HTMLDetailsElement)) return;
        // Desktop: expanded for quick scanning.
        // Mobile: collapsed by default to reduce initial height.
        details.open = !isMobile;
      });

      // Enable chevron transitions only after initial open/closed state is set.
      filtersRoot.classList.add('collection-filters--hydrated');
    };

    filtersRoot.querySelectorAll('[data-collection-filter]').forEach((details) => {
      if (!(details instanceof HTMLDetailsElement)) return;
      details.addEventListener('toggle', () => {
        userAdjustedFilters = true;
      });
    });

    applyDefaultFilterAccordionState();
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', applyDefaultFilterAccordionState);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(applyDefaultFilterAccordionState);
    }

    if (!form) return;

    const filterToggles = form.querySelectorAll('[data-filter-url]');
    filterToggles.forEach((input) => {
      input.addEventListener('change', () => {
        const url = input.getAttribute('data-filter-url');
        if (url) {
          window.location.href = url;
        }
      });
    });

    const sortSelect = document.querySelector('#sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-header]');
    const dockSpacer = document.querySelector('[data-header-dock-spacer]');
    const scrollTopHitarea = document.querySelector('[data-header-scroll-top]');
    const toggle = document.querySelector('[data-header-menu-toggle]');
    const nav = document.querySelector('[data-header-nav]');
    const backdrop = document.querySelector('[data-header-nav-backdrop]');
    const shopDropdown = document.querySelector('[data-header-shop-dropdown]');
    const shopTrigger = document.querySelector('[data-header-shop-trigger]');
    const shopMenu = document.querySelector('[data-header-shop-menu]');
    if (!header || !dockSpacer || !toggle || !nav || !backdrop) return;

    const mobileMq = window.matchMedia('(max-width: 749px)');

    const isMobile = () => mobileMq.matches;

    const syncMenuToggleClonePosition = () => {
      if (!header.classList.contains('header--nav-open')) return;
      const rect = toggle.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-menu-toggle-top', `${Math.round(rect.top)}px`);
      document.documentElement.style.setProperty('--header-menu-toggle-left', `${Math.round(rect.left)}px`);
    };

    const syncHeaderOpenTop = () => {
      const y = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-open-top', `${Math.round(y)}px`);
      syncMenuToggleClonePosition();
    };

    let navCloseTimer = null;
    let onBackdropTransitionEnd = null;

    const clearPendingNavClose = () => {
      if (navCloseTimer != null) {
        clearTimeout(navCloseTimer);
        navCloseTimer = null;
      }
      if (onBackdropTransitionEnd) {
        backdrop.removeEventListener('transitionend', onBackdropTransitionEnd);
        onBackdropTransitionEnd = null;
      }
    };

    const unlockScrollAndHeaderLayer = () => {
      if (!document.documentElement.hasAttribute('data-header-scroll-locked')) return;
      const prev = document.documentElement.dataset.headerPrevOverflow || '';
      document.documentElement.style.overflow = prev;
      delete document.documentElement.dataset.headerPrevOverflow;
      document.documentElement.removeAttribute('data-header-scroll-locked');
    };

    /**
     * Removing `data-header-scroll-locked` drops header z-index immediately while the
     * backdrop is still fading (0.18s), which flashes PDP scallops above the scrim.
     * Wait for opacity transition end (+ timeout fallback) before unlock.
     */
    const scheduleUnlockAfterBackdropClose = () => {
      clearPendingNavClose();
      const done = () => {
        clearPendingNavClose();
        unlockScrollAndHeaderLayer();
      };
      onBackdropTransitionEnd = (event) => {
        if (event.target !== backdrop || event.propertyName !== 'opacity') return;
        done();
      };
      backdrop.addEventListener('transitionend', onBackdropTransitionEnd);
      navCloseTimer = window.setTimeout(done, 280);
    };

    const setOpen = (open) => {
      if (!isMobile()) {
        clearPendingNavClose();
        unlockScrollAndHeaderLayer();
        header.classList.remove('header--nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        nav.removeAttribute('inert');
        nav.setAttribute('aria-hidden', 'false');
        backdrop.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('inert', '');
        return;
      }

      header.classList.toggle('header--nav-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        header.classList.remove('header--idle-hidden');
        clearPauseShowTimer();
        clearPendingNavClose();
        nav.removeAttribute('inert');
        nav.setAttribute('aria-hidden', 'false');
        backdrop.removeAttribute('inert');
        backdrop.setAttribute('aria-hidden', 'false');
      } else {
        nav.setAttribute('inert', '');
        nav.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('inert', '');
        backdrop.setAttribute('aria-hidden', 'true');
      }

      syncHeaderOpenTop();
      if (open) {
        requestAnimationFrame(() => syncHeaderOpenTop());
      }

      if (open) {
        if (!document.documentElement.hasAttribute('data-header-scroll-locked')) {
          document.documentElement.setAttribute('data-header-scroll-locked', '');
          const previousOverflow = document.documentElement.style.overflow;
          document.documentElement.dataset.headerPrevOverflow = previousOverflow;
          document.documentElement.style.overflow = 'hidden';
        }
      } else {
        scheduleUnlockAfterBackdropClose();
        if (header.classList.contains('header--dock-fixed')) {
          header.classList.remove('header--idle-hidden');
          clearPauseShowTimer();
        }
      }

      syncScrollTopHitarea();
    };

    const isOpen = () => header.classList.contains('header--nav-open');

    const closeShopDropdown = () => {
      if (!shopDropdown || !shopTrigger || !shopMenu) return;
      shopDropdown.classList.remove('header__nav-dropdown--open');
      shopTrigger.setAttribute('aria-expanded', 'false');
    };

    const openShopDropdown = () => {
      if (!shopDropdown || !shopTrigger) return;
      shopDropdown.classList.add('header__nav-dropdown--open');
      shopTrigger.setAttribute('aria-expanded', 'true');
    };

    const toggleShopDropdown = () => {
      if (!shopDropdown) return;
      if (shopDropdown.classList.contains('header__nav-dropdown--open')) {
        closeShopDropdown();
      } else {
        openShopDropdown();
      }
    };

    shopTrigger?.addEventListener('click', (event) => {
      if (isMobile()) return;
      event.preventDefault();
      event.stopPropagation();
      toggleShopDropdown();
    });

    shopMenu?.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      if (isMobile()) return;
      closeShopDropdown();
    });

    document.addEventListener('click', (event) => {
      if (isMobile()) return;
      if (!shopDropdown || shopDropdown.contains(event.target)) return;
      closeShopDropdown();
    });

    let dockThreshold = 0;
    /** Don't auto-hide until scroll clears the dock spacer (avoids white gap under a short scroll). */
    let navHideScrollMin = 0;

    const PAUSE_SHOW_MS = 400;
    let pauseShowTimer = null;

    const clearPauseShowTimer = () => {
      if (pauseShowTimer != null) {
        clearTimeout(pauseShowTimer);
        pauseShowTimer = null;
      }
    };

    const clearMobileDock = () => {
      header.classList.remove('header--dock-fixed', 'header--stuck', 'header--idle-hidden');
      dockSpacer.classList.remove('is-active');
      dockSpacer.style.height = '';
      dockSpacer.hidden = true;
      clearPauseShowTimer();
    };

    /** Hide docked nav while scrolling; reveal after PAUSE_SHOW_MS of no scroll. */
    const syncDockedNavScrollVisibility = () => {
      if (!isMobile() || isOpen() || !header.classList.contains('header--dock-fixed')) {
        header.classList.remove('header--idle-hidden');
        clearPauseShowTimer();
        return;
      }

      if (window.scrollY < navHideScrollMin) {
        header.classList.remove('header--idle-hidden');
        clearPauseShowTimer();
        return;
      }

      header.classList.add('header--idle-hidden');
      clearPauseShowTimer();
      pauseShowTimer = window.setTimeout(() => {
        pauseShowTimer = null;
        if (!isMobile() || isOpen() || !header.classList.contains('header--dock-fixed')) return;
        header.classList.remove('header--idle-hidden');
      }, PAUSE_SHOW_MS);
    };

    const updateNavHideScrollMin = () => {
      const scallop =
        parseFloat(getComputedStyle(header).getPropertyValue('--header-scallop-radius')) || 0;
      navHideScrollMin = dockThreshold + header.offsetHeight + Math.round(scallop);
    };

    /** Document Y where the header row would meet the viewport top (after announcement scrolls off). */
    const measureDockThreshold = () => {
      clearMobileDock();
      dockThreshold = Math.max(0, Math.round(window.scrollY + header.getBoundingClientRect().top));
      updateNavHideScrollMin();
    };

    const syncMobileDock = () => {
      if (!isMobile()) {
        clearMobileDock();
        return;
      }

      const shouldDock = window.scrollY >= dockThreshold;

      if (shouldDock) {
        if (!header.classList.contains('header--dock-fixed')) {
          dockSpacer.style.height = `${header.offsetHeight}px`;
          dockSpacer.hidden = false;
          dockSpacer.classList.add('is-active');
          header.classList.add('header--dock-fixed');
          updateNavHideScrollMin();
        }
        header.classList.add('header--stuck');
      } else {
        clearMobileDock();
      }

      if (isOpen()) syncHeaderOpenTop();
    };

    const scrollToTop = () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    const syncScrollTopHitarea = () => {
      if (!scrollTopHitarea) return;
      const active = isMobile() && window.scrollY > 0 && !isOpen();
      scrollTopHitarea.hidden = !active;
      scrollTopHitarea.disabled = !active;
    };

    const onMobileScroll = () => {
      if (!isMobile()) return;
      syncMobileDock();
      syncScrollTopHitarea();
      if (header.classList.contains('header--dock-fixed') && !isOpen()) {
        syncDockedNavScrollVisibility();
      } else {
        header.classList.remove('header--idle-hidden');
        clearPauseShowTimer();
      }
    };

    scrollTopHitarea?.addEventListener('click', () => {
      if (!isMobile() || window.scrollY <= 0 || isOpen()) return;
      header.classList.remove('header--idle-hidden');
      clearPauseShowTimer();
      scrollToTop();
    });

    const syncLayoutMode = () => {
      closeShopDropdown();
      if (!isMobile()) {
        setOpen(false);
        nav.removeAttribute('inert');
        nav.setAttribute('aria-hidden', 'false');
        backdrop.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('inert', '');
        header.classList.remove('header--nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        clearMobileDock();
        syncScrollTopHitarea();
        return;
      }

      measureDockThreshold();
      syncScrollTopHitarea();

      // Mobile: start closed unless already open
      if (!isOpen()) {
        nav.setAttribute('inert', '');
        nav.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('inert', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
    };

    toggle.addEventListener('click', () => {
      if (!isMobile()) return;
      setOpen(!isOpen());
    });

    backdrop.addEventListener('click', () => {
      if (!isMobile()) return;
      setOpen(false);
    });

    nav.addEventListener('click', (event) => {
      const target = event.target;
      if (!isMobile()) return;
      if (target && target.closest && target.closest('a')) {
        setOpen(false);
      }
    });

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        setOpen(false);
      }
      if (event.key === 'Escape' && shopDropdown?.classList.contains('header__nav-dropdown--open')) {
        closeShopDropdown();
        shopTrigger?.focus();
      }
    });

    window.addEventListener('scroll', onMobileScroll, { passive: true });

    window.addEventListener('resize', () => {
      if (isMobile()) measureDockThreshold();
      syncLayoutMode();
      syncMobileDock();
      syncScrollTopHitarea();
      if (isOpen()) syncHeaderOpenTop();
    });

    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', () => {
        syncLayoutMode();
        syncMobileDock();
      });
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(() => {
        syncLayoutMode();
        syncMobileDock();
      });
    }

    syncLayoutMode();
    syncMobileDock();
    syncScrollTopHitarea();
    if (isMobile() && header.classList.contains('header--dock-fixed') && !isOpen()) {
      syncDockedNavScrollVisibility();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.product__quantity-control');
    if (container) {
      const input = container.querySelector('[data-qty-input]');
      const buttons = container.querySelectorAll('[data-qty-change]');
      const minusButton = container.querySelector('[data-qty-change="-1"]');
      const plusButton = container.querySelector('[data-qty-change="1"]');

      const syncState = () => {
        const current = Number(input.value) || 1;
        const min = Number(input.getAttribute('min')) || 1;
        const hasMax = input.hasAttribute('max');
        const max = hasMax ? Number(input.getAttribute('max')) : Infinity;
        const clamped = Math.min(max, Math.max(min, current));
        if (clamped !== current) {
          input.value = clamped;
        }
        if (minusButton) {
          minusButton.disabled = clamped <= min;
        }
        if (plusButton) {
          plusButton.disabled = clamped >= max;
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const delta = Number(button.getAttribute('data-qty-change'));
          const current = Number(input.value) || 1;
          const min = Number(input.getAttribute('min')) || 1;
          const hasMax = input.hasAttribute('max');
          const max = hasMax ? Number(input.getAttribute('max')) : Infinity;
          const next = Math.min(max, Math.max(min, current + delta));
          input.value = next;
          syncState();
        });
      });

      input.addEventListener('change', syncState);
      syncState();
    }

    const lightbox = document.querySelector('.product-lightbox');
    const lightboxImage = document.querySelector('.product-lightbox__image');
    const lightboxBackdrop = lightbox ? lightbox.querySelector('[data-lightbox-backdrop]') : null;
    const isMobileViewport = window.matchMedia('(max-width: 900px)');

    const mobileGallery = document.querySelector('[data-mobile-gallery]');
    const mobileTrack = mobileGallery ? mobileGallery.querySelector('[data-mobile-gallery-track]') : null;
    const mobileSlides = mobileTrack ? Array.from(mobileTrack.querySelectorAll('[data-mobile-gallery-slide]')) : [];
    const mobileDots = mobileGallery ? Array.from(mobileGallery.querySelectorAll('[data-mobile-gallery-dot]')) : [];

    if (mobileTrack && mobileSlides.length) {
      const mobileImages = Array.from(mobileTrack.querySelectorAll('.product__media-mobile-slide .image img'));

      const getSlideStep = () =>
        mobileSlides.length > 1
          ? mobileSlides[1].offsetLeft - mobileSlides[0].offsetLeft
          : mobileTrack.clientWidth;

      const getNearestMobileSlide = () => {
        const n = mobileSlides.length;
        if (n < 2) return 0;
        const step = getSlideStep();
        if (step > 0) {
          return Math.max(0, Math.min(n - 1, Math.round(mobileTrack.scrollLeft / step)));
        }
        return 0;
      };

      const setActiveMobileDot = (index) => {
        if (!mobileDots.length) return;
        mobileDots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const updateMobileScrollFade = () => {
        if (mobileSlides.length < 2) {
          mobileSlides.forEach((slide) => {
            const wrap = slide.querySelector('.image');
            if (wrap) wrap.style.removeProperty('opacity');
          });
          return;
        }
        const t = mobileTrack.scrollLeft;
        const step = getSlideStep();
        if (step <= 0) return;
        const f = t / step;
        const n = mobileSlides.length;
        const iIndex = Math.max(0, Math.min(n - 1, Math.floor(f + 0.000001)));
        const local = f - iIndex;

        if (iIndex >= n - 1) {
          mobileSlides.forEach((slide, j) => {
            const el = slide.querySelector('.image');
            if (el) el.style.opacity = j === n - 1 ? '1' : '0';
          });
          return;
        }

        mobileSlides.forEach((slide, j) => {
          const el = slide.querySelector('.image');
          if (!el) return;
          if (j === iIndex) el.style.opacity = String(1 - local);
          else if (j === iIndex + 1) el.style.opacity = String(local);
          else el.style.opacity = '0';
        });
      };

      const updateMobileFrameHeight = () => {
        const slideWidth = mobileTrack.clientWidth;
        if (!slideWidth || !mobileImages.length) return;

        const tallestHeight = mobileImages.reduce((maxHeight, img) => {
          const naturalWidth = img.naturalWidth || Number(img.getAttribute('width')) || 0;
          const naturalHeight = img.naturalHeight || Number(img.getAttribute('height')) || 0;
          if (!naturalWidth || !naturalHeight) return maxHeight;
          const renderedHeight = slideWidth * (naturalHeight / naturalWidth);
          return Math.max(maxHeight, renderedHeight);
        }, 0);

        if (tallestHeight > 0) {
          mobileGallery.style.setProperty('--mobile-gallery-frame-height', `${Math.ceil(tallestHeight)}px`);
        } else {
          mobileGallery.style.removeProperty('--mobile-gallery-frame-height');
        }
        requestAnimationFrame(() => {
          updateMobileScrollFade();
        });
      };

      window.addEventListener('resize', updateMobileFrameHeight);
      mobileImages.forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', updateMobileFrameHeight, { once: true });
        }
      });
      updateMobileFrameHeight();

      let mobileScrollTicking = false;
      mobileTrack.addEventListener(
        'scroll',
        () => {
          if (mobileScrollTicking) return;
          mobileScrollTicking = true;
          requestAnimationFrame(() => {
            updateMobileScrollFade();
            if (mobileDots.length) setActiveMobileDot(getNearestMobileSlide());
            mobileScrollTicking = false;
          });
        },
        { passive: true }
      );

      if (mobileDots.length) {
        mobileDots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const targetIndex = Number(dot.getAttribute('data-mobile-gallery-index')) || 0;
            const targetSlide = mobileSlides[targetIndex];
            if (targetSlide) {
              mobileTrack.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
            }
            setActiveMobileDot(targetIndex);
            requestAnimationFrame(() => {
              updateMobileScrollFade();
            });
          });
        });
      }

      requestAnimationFrame(() => {
        updateMobileScrollFade();
        if (mobileDots.length) setActiveMobileDot(getNearestMobileSlide());
      });
    }

    const variantSelect = document.querySelector('.product__variant-select');
    const featuredMediaRoot = document.querySelector('[data-featured-media-root]');
    const featuredMediaImage = featuredMediaRoot ? featuredMediaRoot.querySelector('.image img') : null;
    const stockEl = document.querySelector('[data-product-stock]');
    const qtyInput = document.querySelector('[data-qty-input]');

    const applyInventory = (tracked, continueSelling, quantity) => {
      const qty = Number(quantity);
      const threshold = Number(stockEl?.getAttribute('data-inventory-threshold')) || 10;
      const isTracked = tracked === 'true';
      const canOversell = continueSelling === 'true';
      const showStock = isTracked && !canOversell && Number.isFinite(qty) && qty > 0 && qty <= threshold;

      if (qtyInput) {
        if (isTracked && !canOversell && Number.isFinite(qty) && qty > 0) {
          qtyInput.setAttribute('max', String(qty));
        } else {
          qtyInput.removeAttribute('max');
        }
        qtyInput.dispatchEvent(new Event('change'));
      }

      if (!stockEl) return;
      if (!showStock) {
        stockEl.textContent = '';
        stockEl.hidden = true;
        return;
      }

      const template = qty === 1
        ? stockEl.getAttribute('data-label-one')
        : stockEl.getAttribute('data-label-other');
      stockEl.textContent = (template || '').replaceAll('__COUNT__', String(qty));
      stockEl.hidden = false;
    };

    const swapFeaturedImageById = (imageId) => {
      if (!featuredMediaRoot || !featuredMediaImage || !imageId) return;
      const sourceImage = document.querySelector(`[data-image-id="${imageId}"] .image img`);
      if (!sourceImage) return;

      // Keep desktop featured media in sync with selected variant image.
      featuredMediaRoot.setAttribute('data-image-id', String(imageId));

      const src = sourceImage.currentSrc || sourceImage.getAttribute('src');
      const srcset = sourceImage.getAttribute('srcset');
      const sizes = sourceImage.getAttribute('sizes');
      const alt = sourceImage.getAttribute('alt');
      const width = sourceImage.getAttribute('width');
      const height = sourceImage.getAttribute('height');

      if (src) featuredMediaImage.setAttribute('src', src);
      if (srcset) featuredMediaImage.setAttribute('srcset', srcset);
      else featuredMediaImage.removeAttribute('srcset');
      if (sizes) featuredMediaImage.setAttribute('sizes', sizes);
      else featuredMediaImage.removeAttribute('sizes');
      if (alt != null) featuredMediaImage.setAttribute('alt', alt);
      if (width) featuredMediaImage.setAttribute('width', width);
      if (height) featuredMediaImage.setAttribute('height', height);
    };

    if (variantSelect) {
      const syncVariantFeaturedImage = () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (!selectedOption) return;
        const featuredImageId = selectedOption.getAttribute('data-featured-image-id');
        if (featuredImageId) {
          swapFeaturedImageById(featuredImageId);
        }
      };

      const syncVariantInventory = () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (!selectedOption) return;
        applyInventory(
          selectedOption.getAttribute('data-inventory-tracked'),
          selectedOption.getAttribute('data-inventory-continue'),
          selectedOption.getAttribute('data-inventory-quantity')
        );
      };

      variantSelect.addEventListener('change', () => {
        syncVariantFeaturedImage();
        syncVariantInventory();
      });
      syncVariantFeaturedImage();
      syncVariantInventory();
    }

    if (!lightbox || !lightboxImage) return;
    if (isMobileViewport.matches) return;

    const images = Array.from(document.querySelectorAll('.product__media .image img'));
    if (!images.length) return;
    const galleryTrigger = document.querySelector('[data-open-lightbox]');

    let currentIndex = 0;
    let previousOverflow = '';

    const setScrollLock = (locked) => {
      if (locked) {
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = previousOverflow;
      }
    };

    const showImage = (index) => {
      currentIndex = (index + images.length) % images.length;
      const img = images[currentIndex];
      lightboxImage.src = img.currentSrc || img.src;
      lightboxImage.alt = img.alt || '';
      requestAnimationFrame(updateLightboxControlsPosition);
    };

    const updateLightboxControlsPosition = () => {
      if (!lightbox.open) return;

      const lightboxRect = lightbox.getBoundingClientRect();
      const safeInset = Math.max(88, Math.min(lightboxRect.width * 0.09, 128));
      const availableWidth = Math.max(0, lightboxRect.width - safeInset * 2);
      const availableHeight = Math.max(0, lightboxRect.height - safeInset * 2);

      const getAspect = (img) => {
        const naturalW = img.naturalWidth || Number(img.getAttribute('width')) || 1;
        const naturalH = img.naturalHeight || Number(img.getAttribute('height')) || 1;
        return naturalH > 0 ? naturalW / naturalH : 1;
      };

      const galleryCapWidth = images.reduce((maxWidth, img) => {
        const aspect = getAspect(img);
        const fitWidth = Math.min(availableWidth, availableHeight * aspect);
        return Math.max(maxWidth, fitWidth);
      }, 0);

      const galleryMinFitWidth = images.reduce((minWidth, img) => {
        const aspect = getAspect(img);
        const fitWidth = Math.min(availableWidth, availableHeight * aspect);
        return Math.min(minWidth, fitWidth);
      }, Number.POSITIVE_INFINITY);

      const cappedWidth = Math.max(
        0,
        Math.min(availableWidth, galleryCapWidth || availableWidth, Number.isFinite(galleryMinFitWidth) ? galleryMinFitWidth : availableWidth)
      );
      const galleryLeft = (lightboxRect.width - cappedWidth) / 2;
      const galleryRight = galleryLeft + cappedWidth;
      const galleryCenterY = lightboxRect.height / 2;

      const imageRect = lightboxImage.getBoundingClientRect();
      if (!imageRect.width || !imageRect.height) return;

      const imageLeft = imageRect.left - lightboxRect.left;
      const imageRight = imageRect.right - lightboxRect.left;
      const imageTop = imageRect.top - lightboxRect.top;
      const imageCenterY = imageRect.top - lightboxRect.top + imageRect.height / 2;

      lightbox.style.setProperty('--lightbox-gallery-width', `${cappedWidth}px`);
      lightbox.style.setProperty('--lightbox-gallery-left', `${galleryLeft}px`);
      lightbox.style.setProperty('--lightbox-gallery-right', `${galleryRight}px`);
      lightbox.style.setProperty('--lightbox-gallery-center-y', `${galleryCenterY}px`);
      lightbox.style.setProperty('--lightbox-image-left', `${imageLeft}px`);
      lightbox.style.setProperty('--lightbox-image-right', `${imageRight}px`);
      lightbox.style.setProperty('--lightbox-image-top', `${imageTop}px`);
      lightbox.style.setProperty('--lightbox-image-center-y', `${imageCenterY}px`);
    };

    const openLightboxAt = (index) => {
      currentIndex = index;
      showImage(currentIndex);
      if (typeof lightbox.showModal === 'function' && !lightbox.open) {
        lightbox.showModal();
        setScrollLock(true);
        requestAnimationFrame(updateLightboxControlsPosition);
      }
    };

    const closeLightbox = () => {
      if (lightbox.open) lightbox.close();
    };

    images.forEach((img, index) => {
      img.addEventListener('click', () => {
        if (isMobileViewport.matches) return;
        openLightboxAt(index);
      });
    });

    if (galleryTrigger) {
      galleryTrigger.addEventListener('click', () => {
        if (isMobileViewport.matches) return;
        openLightboxAt(0);
      });
    }

    const prevButton = lightbox.querySelector('.product-lightbox__nav--prev');
    const nextButton = lightbox.querySelector('.product-lightbox__nav--next');
    if (prevButton) {
      prevButton.addEventListener('click', () => showImage(currentIndex - 1));
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => showImage(currentIndex + 1));
    }

    const closeButton = lightbox.querySelector('.product-lightbox__close');
    if (closeButton) {
      closeButton.addEventListener('click', closeLightbox);
    }

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightboxBackdrop || event.target === lightbox) closeLightbox();
    });

    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentIndex + 1);
      }
    });

    lightbox.addEventListener('close', () => setScrollLock(false));
    lightbox.addEventListener('cancel', () => setScrollLock(false));
    lightboxImage.addEventListener('load', updateLightboxControlsPosition);
    window.addEventListener('resize', updateLightboxControlsPosition);
  });

  } catch(e) { console.error(e); }
})();
})();
